var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgAppleMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 661,
    height: 661,
    viewBox: "0 0 661 661",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.276 1.09814H508.723C592.475 1.09814 659.902 68.5235 659.902 152.276V508.723C659.902 592.476 592.477 659.902 508.723 659.902H152.276C68.5232 659.902 1.0979 592.477 1.0979 508.724V152.276C1.0979 68.5235 68.5232 1.09814 152.276 1.09814Z",
    fill: "url(#paint0_linear_468_7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M447.847 135.148L251.583 188.219H251.355V268.051H251.583V410.792C242.996 405.625 232.47 402.557 221.16 402.557C192.027 402.557 168.552 422.79 168.552 447.619C168.552 472.456 192.033 492.455 221.16 492.455C250.287 492.455 275.043 472.435 274.004 447.62L273.469 434.883L272.174 262.327L427.264 220.464V378.071C418.209 371.828 406.65 368.007 394.096 368.007C364.963 368.007 341.48 388.24 341.48 413.069C341.48 437.906 364.963 457.904 394.096 457.904C423.23 457.904 447.715 437.906 447.715 413.069C447.715 412.835 447.723 412.616 447.715 412.381L447.855 214.967V135.148H447.847Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_7",
    x1: 330.177,
    y1: 657.253,
    x2: 330.818,
    y2: 9.04661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA1E38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5C75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAppleMusicIcon);
export default __webpack_public_path__ + "static/media/img-apple-music-icon.897c86eac632869080ce6ecd978aba8c.svg";
export { ForwardRef as ReactComponent };